<script lang="ts" setup>

import {computed} from "vue";
import {Price} from "~app/stripe";
import StripeCheckoutButton from "~components/StripeCheckoutButton.vue";
import {UserInfo} from "@/common/utils/auth";

const props = defineProps<{
  price?: Price
  title?: string
  user?: UserInfo
  points: string[],
}>()

const productTitle = computed(() => props.title ?? props.price?.product.name)
const email = computed(() => props.user?.email)

</script>

<template>
  <div class="product-card shadow shadow shadow-lg">
    <slot name="title">
      <div class="title">{{ productTitle }}</div>
    </slot>

    <slot name="cta">
      <StripeCheckoutButton v-if="price && email" class="checkout-button" :price="price" :email="email"/>
    </slot>

    <slot name="points">
      <ul>
        <li v-for="point in points" :key="point">{{ point }}</li>
      </ul>
    </slot>
  </div>
</template>

<style scoped lang="scss">
.product-card {
  max-width: 30rem;
  border: 1px solid #ccc;

  border-radius: 1rem;
  padding: 0.5rem;
  text-align: center;
}

.title {
  font-size: 1.25rem;
  font-weight: bold;
  margin: 0.5rem;
}

.checkout-button {
  margin: 1rem;
}

ul {
  text-align: justify;
}
</style>
